import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import AppContext from "./util/AppContext";

// Components
import Form from './components/Form/Form';
import Navbar from './components/Navbar/Navbar';
import Pricing from './components/Pricing/Pricing';
import Community from './pages/Community';
import Education from './pages/Education';
import Event from './pages/Event';
import Home from './pages/Home';
import Office from './pages/Office';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RevirtClub from './pages/RevirtClub';

function App() {
  const [navbarHeight, setNavbarHeight] = useState('');
  const [gotQueriesHeight, setGotQueriesHeight] = useState('');
  const [footerHeight, setFooterHeight] = useState('');
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)

  const values = {
    navbarHeight,
    setNavbarHeight,
    gotQueriesHeight,
    setGotQueriesHeight,
    windowHeight,
    setWindowHeight,
    footerHeight,
    setFooterHeight
  }

  useEffect(() => {

  }, [])
  
  return (
    <AppContext.Provider value={values}>
      <Navbar />
      <div className='component-holder'>
        <Routes>
          <Route path='/' element={<Home />}/>
          <Route path='/education' element={<Education/>}/>
          <Route path='/office' element={<Office/>}/>
          <Route path='/event' element={<Event/>}/>
          <Route path='/revirtclub' element={<RevirtClub/>}/>
          <Route path='/community' element={<Community/>}/>
          <Route path='/pricing' element={<Pricing/>}/>
          <Route path='/form' element={<Form/>}/>
          <Route path='/privacypolicy' element={<PrivacyPolicy/>}/>
        </Routes>
      </div>
    </AppContext.Provider>
  );
}

export default App;
